var ezdia;
(function (ezdia) {
    var actionObj = {};
    var pageParams = null;
    var rowTemplate = null;
    var schema = {};
    var widgettype = 'ez.new';
    var form = 'ez-form-new-field-create';
    var wrapper = function (id) {
        var wrapperObj = $("#" + id);
        if (!wrapperObj.length) {
            var divs = $('<div>', {
                id: id
            });
            $('body').append(divs);
            wrapperObj = $("#" + id);
        }
        return wrapperObj;
    };
    var markup = function (inputs, column) {
        var content = '';
        content = rowTemplate(column);
        content = $(content);
        content.find('[data-row="input"]').append(inputs);
        return content;
    };
    var getColumn = function (columnProps, type) {
        var column = columnProps;
        var obj = {
            column: column,
            value: column.default
        };
        if (type === 'singlechoice') {
            column.edittype = 'inputlist';
        }
        else {
            column.edittype = column.type;
        }
        column.id = "ez-new-fields-input-" + column.id;
        column.label = column.title;
        column.editable = true;
        return obj;
    };
    function getConfigOpt(elem) {
        var type = elem.value;
        var index = $(elem).data('index');
        var obj = schema.properties[type];
        var config = {};
        var container = $("#ez-fields-configs" + index).empty();
        if (!this.value) {
            return;
        }
        rowTemplate = $.ezdia.template.get('base-form-row');
        if (!obj.properties) {
            return;
        }
        config = obj.properties.config.properties;
        $.each(config, function (k, column) {
            var objCol = getColumn(column, type);
            var content = '';
            switch (column.type) {
                case 'boolean':
                    content = $.ezdia.inputs.boolean(objCol);
                    break;
                case 'object':
                    content = $.ezdia.inputs.textarea(objCol);
                    break;
                default:
                    content = $.ezdia.inputs.textbox(objCol);
                    break;
            }
            $.ezdia.widgets.init(objCol, widgettype);
            content = markup(content, column);
            container.append(content);
        });
        $.ezdia.widgets.create(widgettype);
    }
    var getGroupObj = function () {
        var colGroup = pageParams.colGroup;
        if (colGroup) {
            colGroup = colGroup.replace('[', '').replace(']', '');
            colGroup = $.map(colGroup.split(','), function (mval) { return mval.trim(); });
        }
        else {
            colGroup = [];
        }
        colGroup.push('default');
        return colGroup;
    };
    var openFieldWindow = function (obj) {
        var template = $.ezdia.template.get('base-new-fileds');
        var wrapperObj = wrapper('ez-new-field-wrapper');
        var content = null;
        var exObj = {
            fieldCount: obj.array || [{ index: 0 }],
            single: obj.array && obj.array.length === 1,
            colGroup: getGroupObj()
        };
        var context = $.extend({}, exObj, schema);
        content = template(context);
        wrapperObj.html(content);
        wrapperObj.dialog({
            modal: true,
            title: 'New Fields',
            width: 600,
            height: 450,
            buttons: [
                {
                    text: 'Submit',
                    class: 'btn-primary',
                    click: function (event) {
                        saveData($(this), event);
                    }
                }
            ]
        });
    };
    var bindEvents = function () {
        var frm = $("#" + form);
        frm
            .find('select[id^="ez-new-field-inputs-field_edittype"]')
            .off('change')
            .on('change', function change() {
            getConfigOpt(this);
        });
        frm
            .find('input[id^="ez-checkbox-unmap"]')
            .off('click')
            .on('click', function click() {
            toggleCreateField.call(this);
        });
        frm
            .find('input[id^="ez-new-field-inputs-label"]')
            .off('keyup')
            .on('keyup', function keyup() {
            var index = $(this).data('index');
            frm.find("span#label" + index).text(this.value);
        });
    };
    var validate = function (array) {
        if (!array) {
            return;
        }
        var vaildObj = {
            rules: {}
        };
        $.each(array, function (i, obj) {
            vaildObj.rules["label" + obj.index] = 'required';
            vaildObj.rules["field_edittype" + obj.index] = 'required';
        });
        $.ezdia.validate.create(vaildObj, form);
    };
    function toggleCreateField() {
        var value = this.value;
        var labelField = $("[name=\"label" + value + "\"]");
        var select = $("[name=\"field_edittype" + value + "\"]");
        $("#ez-new-field-inputs-body" + value)
            .collapse('toggle')
            .toggleClass('ignore');
        $("#ez-new-field-inputs-heading" + value).toggleClass('collapsed');
        $("#ez-new-field-inputs-panel" + value).toggleClass('collapsed');
        if (this.checked) {
            labelField.rules('add', {
                required: true
            });
            select.rules('add', {
                required: true
            });
        }
        else {
            labelField.rules('remove');
            select.rules('remove');
        }
    }
    var getSinglechoiceOptions = function (value) {
        var json = ezdia.util.jsonParse(value);
        var content = {};
        $.each(json, function (i, obj) {
            content[obj.value] = obj.value;
        });
        return content;
    };
    var getConfigValue = function (value, type) {
        var content = '';
        switch (type) {
            case 'boolean':
                content = !!+value;
                break;
            case 'integer':
                content = value ? +value : '';
                break;
            case 'inputlist':
                content = value ? getSinglechoiceOptions(value) : '';
                break;
            default:
                content = value;
                break;
        }
        return content;
    };
    var getData = function (frm) {
        var rows = frm.find('div[data-inputs="inputs"]').not('.ignore');
        var arr = [];
        $.each(rows, function eachrows() {
            var data = $(this).find('[name]');
            var json = {
                editable: true
            };
            $.each(data, function eachdata() {
                var elem = $(this);
                var name = this.name;
                var value = this.value;
                var type = elem.data('type');
                if (type === 'label') {
                    json.label = value;
                    json.name = $.ezdia.sanitizer.specialChar(value);
                }
                else if (type === 'edittype') {
                    json.edittype = value;
                    json.fieldType = value;
                }
                else if (type === 'group') {
                    json.group_name = value;
                }
                else {
                    if (!json.config) {
                        json.config = {};
                    }
                    json.config[name] = getConfigValue(value, type);
                }
            });
            arr.push(json);
        });
        return JSON.stringify(arr);
    };
    var saveData = function (panel, e) {
        pageParams = $.ezdia.config.pageParams;
        var frm = $("#" + form);
        if (!frm.valid()) {
            return;
        }
        var data = "accountName=" + pageParams.account + "&role=" + pageParams.role + "&config=" + getData(frm);
        var btn = $(e.currentTarget).button('loading');
        $.ajax({
            type: 'POST',
            url: 'addFieldAction.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                btn.button('reset');
                var responseText = response;
                if (responseText.success) {
                    if (actionObj.type === 'import') {
                        $.ezdia.import.addField(responseText.field, actionObj);
                        panel.dialog('close');
                    }
                }
                if (!responseText.success) {
                    $('div#ez-form-new-field-create-msg')
                        .html(responseText.message)
                        .fadeIn();
                }
            }
        });
    };
    // eslint-disable-next-line import/prefer-default-export
    ezdia.createNewField = {
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        create: function (type) {
            pageParams = $.ezdia.config.pageParams;
            actionObj = {};
            if (typeof type === 'string') {
                actionObj.type = type;
            }
            else {
                actionObj = type;
            }
            $.ezdia.widgets.load(widgettype);
            schema = $.ezdia.config.JSONSCHEMA;
            openFieldWindow(type);
            bindEvents();
            validate(type.array);
        }
    };
    /**
     * This line of code for support old code.
     * It should be removed in future
     */
    $.ezdia.field = ezdia.createNewField;
})(ezdia || (ezdia = {}));
